import { differenceInDays } from "date-fns";

// Lead statuses where aging stops being relevant (deal is closed)
export const CLOSED_STATUSES = new Set(["Subscribed", "Lost"]);

// Map audit action keys → human-readable labels
const ACTION_LABELS = {
  lead_created: "Lead Created",
  lead_updated: "Lead Updated",
  lead_status_changed: "Status Changed",
  lead_assigned: "Reassigned",
  lead_deleted: "Lead Deleted",
  note_added: "Note Added",
  meeting_scheduled: "Meeting Scheduled",
  meeting_cancelled: "Meeting Cancelled",
  whatsapp_sent: "WhatsApp Sent",
  teams_invite_sent: "Teams Invite Sent",
  engarage_registered: "ENGARAGE Registered",
  engarage_subscribed: "ENGARAGE Subscribed",
  engarage_matched: "ENGARAGE Linked",
  engarage_merged: "ENGARAGE Merged",
  custom_field_added: "Custom Field Added",
  custom_field_updated: "Custom Field Updated",
  custom_field_deleted: "Custom Field Deleted",
};

export function labelForAction(action) {
  if (!action) return "—";
  return ACTION_LABELS[action] || action.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());
}

/** Days since the given ISO timestamp, never negative. Returns null if invalid. */
export function daysSince(iso) {
  if (!iso) return null;
  try {
    const d = differenceInDays(new Date(), new Date(iso));
    return d < 0 ? 0 : d;
  } catch { return null; }
}

/** Tailwind classes for aging severity (green → red). */
export function agingTone(days) {
  if (days === null || days === undefined) return "text-gray-400";
  if (days <= 1) return "text-emerald-600";
  if (days <= 3) return "text-gray-700";
  if (days <= 7) return "text-amber-600";
  if (days <= 14) return "text-orange-600";
  return "text-red-600";
}

export function agingLabel(days) {
  if (days === null || days === undefined) return "—";
  if (days === 0) return "Today";
  if (days === 1) return "1 day";
  return `${days} days`;
}
